import React, { useRef } from "react";
import { components } from "react-select";
import { Controller } from "react-hook-form";

import AsyncSelect from "react-select/async";

import { Label } from "reactstrap";

import { OptionsComponentStore } from "./OptionCustom/store";
import { CustomCustomerOption } from "./OptionCustom/customer";
import { CustomSimpleStore } from "./OptionCustom/simpleStore";

const CustomOptionStore = ({ children, ...props }) => (
  <components.Option {...props}>
    <OptionsComponentStore data={props} />
  </components.Option>
);

const CustomOptionCustomer = ({ children, ...props }) => (
  <components.Option {...props}>
    <CustomCustomerOption data={props} />
  </components.Option>
);

const CustomOptionDefault = ({ children, ...props }) => (
  <components.Option {...props}>{children}</components.Option>
);

const CustomOptionSimpleStore = ({ children, ...props }) => (
  <components.Option {...props}>
    <CustomSimpleStore data={props.data} />
  </components.Option>
);

const componentsOptions = {
  store: CustomOptionStore,
  cliente: CustomOptionCustomer,
  default: CustomOptionDefault,
  simplestore: CustomOptionSimpleStore,
};

export const SelectAsync = props => {
  const {
    type = "default",
    label = "",
    options,
    control,
    required,
    name,
    defaultValue,
  } = props;

  if (typeof options !== "function") {
    return "Inform os options para a busca";
  }

  const componentOption = componentsOptions[type];

  const resolveSearch = value => {
    const isText = /[a-zA-Z]+/.test(value);
    const isCnpj = /[\d./-]/.test(value);
    if (isCnpj && !isText) {
      const resultado = value.replace(/[./-]/g, "");
      return resultado ?? null;
    }
    return value ?? null;
  };

  const debounceTimeoutRef = useRef(null);

  const promiseOptions = inputValue => {
    let search = inputValue;
    if (type === "store" || type === "cliente" || type === "simplestore") {
      search = resolveSearch(inputValue);
    }

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    return new Promise(resolve => {
      debounceTimeoutRef.current = setTimeout(() => {
        resolve(options(search));
      }, 500);
    });
  };

  if (control) {
    return (
      <>
        <Label>
          {label}
          {required && <span className="text-danger">*</span>}
        </Label>
        <Controller
          rules={{ required }}
          control={control}
          name={name}
          defaultValue={defaultValue}
          render={({ field, defaultValue: defaultValue2 }) => (
            <AsyncSelect
              components={{
                Option: componentOption,
              }}
              loadOptions={promiseOptions}
              {...props}
              defaultValue={defaultValue2}
              {...field}
            />
          )}
        />
      </>
    );
  }

  return (
    <>
      <Label>{label}</Label>
      <AsyncSelect
        components={{
          Option: componentOption,
        }}
        loadOptions={promiseOptions}
        {...props}
      />
    </>
  );
};
